export default "__VITE_ASSET__DcdH7nJ2__"